import { Input } from '~/components/ui/input';
import { Button } from '~/components/ui/button';
import { Search } from 'lucide-react';

export function SearchInputGroup({
  freeWord,
  setFreeWord,
  searchHandler,
}: {
  freeWord: string;
  setFreeWord: (freeWord: string) => void;
  searchHandler: () => void;
}) {
  return (
    <div className="relative flex w-full items-center space-x-2">
      <div className="relative flex-grow">
        <Search className="absolute left-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500 pointer-events-none" />
        <Input
          className="pl-8 pr-4  ring-green-600"
          type="search"
          placeholder="フリーワード"
          value={freeWord}
          onChange={(e) => setFreeWord(e.target.value)}
        />
      </div>
      <Button
        type="button"
        className="bg-green-600 hover:bg-green-700 font-bold tracking-wide"
        onClick={() => searchHandler()}
      >
        検索
      </Button>
    </div>
  );
}
